import {
  IAuditsClosingCloseResponse,
  IAuditsClosingOpenResponse
} from 'types/auditsClosings';
import request from './index';
import toErrorWithMessage from 'utilities/getErrorMessage';

export const closeAuditClosing = async (id: number | string) => {
  try {
    return await request<IAuditsClosingCloseResponse>({
      options: {
        url: `/audits_closings/${id}/close`,
        method: 'patch'
      }
    });
  } catch (e) {
    return { data: null, error: toErrorWithMessage(e) };
  }
};

export const openAuditClosing = async (id: number | string) => {
  try {
    return await request<IAuditsClosingOpenResponse>({
      options: {
        url: `/audits_closings/${id}/open`,
        method: 'patch'
      }
    });
  } catch (e) {
    return { data: null, error: toErrorWithMessage(e) };
  }
};
